import { useMemo } from 'react';
import ReCaptchaLoader from './ReCaptchaLoader';

export const useRecaptchaLoader = () => {
  return useMemo(() => new ReCaptchaLoader(), []);
};
